import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-modal-terms-visitor',
  templateUrl: './modal-terms-visitor.component.html',
  styleUrls: ['./modal-terms-visitor.component.css']
})
export class ModalTermsVisitorComponent implements OnInit {
  bodyTranslation: string
  constructor(public dialogRef: MatDialogRef<ModalTermsVisitorComponent>, private translate: TranslateService) { }

  Accept(){
    this.dialogRef.close(true);
  }
  Close(){
    this.dialogRef.close(false);
  }
  ngOnInit(){
  }

}
